import React from 'react';
import TextPreview from './TextPreview';
import DateTimePreview from './DateTimePreview';
import SelectionPreview from './SelectionPreview';
import DisplayPreview from './DisplayPreview';
import FileUploadPreview from './FileUploadPreview';
import RichTextPreview from './RichTextPreview';
import ListPreview from './ListPreview';
import DynamicFormRenderer from '../DynamicFormRenderer';

const INLINE_EDIT_TYPES = new Set(['dropdown', 'radio', 'checkbox', 'display']);

/* ─── Field preview router (classic builder) ─── */

export function FieldPreview({ field, onUpdate, palette, theme, availablePlaceholders }) {
  switch (field.type) {
    case 'text':
    case 'number':
      return <TextPreview field={field} onUpdate={onUpdate} palette={palette} theme={theme} availablePlaceholders={availablePlaceholders} />;
    case 'date':
    case 'time':
      return <DateTimePreview field={field} onUpdate={onUpdate} palette={palette} theme={theme} />;
    case 'dropdown':
    case 'radio':
    case 'checkbox':
      return <SelectionPreview field={field} onUpdate={onUpdate} palette={palette} theme={theme} availablePlaceholders={availablePlaceholders} />;
    case 'display':
      return <DisplayPreview field={field} onUpdate={onUpdate} palette={palette} theme={theme} availablePlaceholders={availablePlaceholders} />;
    case 'file_upload':
      return <FileUploadPreview field={field} palette={palette} />;
    case 'rich_text':
      return <RichTextPreview field={field} onUpdate={onUpdate} palette={palette} theme={theme} availablePlaceholders={availablePlaceholders} />;
    case 'list':
      return <ListPreview field={field} onUpdate={onUpdate} palette={palette} theme={theme} />;
    default:
      return null;
  }
}

/* ─── Public design body: editable selection/display inline, everything else
   rendered through the real public renderer so it matches the live form ─── */

export function PublicDesignFieldBody({ field, onUpdate, palette, theme, availablePlaceholders }) {
  if (INLINE_EDIT_TYPES.has(field.type)) {
    return (
      <FieldPreview
        field={field}
        onUpdate={onUpdate}
        palette={palette}
        theme={theme}
        availablePlaceholders={availablePlaceholders}
      />
    );
  }

  return (
    <DynamicFormRenderer
      form={{ fields: [field] }}
      answers={{}}
      onChange={() => {}}
      onFieldBlur={null}
      validation={{ errors: {}, warnings: {} }}
      readOnly
      publicMode
      hideLabel
      onUpload={null}
      onRemoveFile={null}
      retryUpload={null}
    />
  );
}
